import React from "react";

export enum PopupActionStatus {
  success,
  submitting,
  failed,
}

export interface PopupContent {
  title: string;
  message: string;
  buttonTitle: string;
  status: PopupActionStatus;
}

interface PopupSingleButtonPropsSingle {
  onClose: () => void;
  popupContent: PopupContent;
}

const PopupSingleButton = ({ onClose, popupContent }: PopupSingleButtonPropsSingle) => {
  const getImageSrc = () => {
    switch (popupContent.status) {
      case PopupActionStatus.success:
        return "/images/success.png";
      case PopupActionStatus.submitting:
        return "/icons/mediaupload.gif";
      case PopupActionStatus.failed:
        return "/icons/failed.png";
      default:
        return "";
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-[290px] h-[401px]">
        <div className="flex flex-col justify-center gap-[15px] h-[300px] content-center items-center pl-[20px] pr-[20px]">
          <div className="w-[93px] h-[93px]">
            <img
              src={getImageSrc()}
              width={80}
              height={80}
              alt={
                popupContent.status === PopupActionStatus.success
                  ? "Success"
                  : popupContent.status === PopupActionStatus.submitting
                  ? "Submitting"
                  : "Failed"
              }
            />
          </div>
          <div>
            <h2 className="popup-title">{popupContent.title}</h2>
          </div>
          <div>
            <p className="popup-sub-title">{popupContent.message}</p>{" "}
          </div>
        </div>
        <div className="flex flex-col content-center items-center gap-[20px]">
          <div className="thickseparator"></div>
          <button className="text-black bg-white popup-button-action" onClick={onClose}>
            {popupContent.buttonTitle}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupSingleButton;
